import MpgJson from "./mpgJson";

export default class Mpg {
  city: string | null;
  combined: string | null;
  highway: string | null;

  constructor() {
    this.city = null;
    this.combined = null;
    this.highway = null;
  }

  static fromJSON(json: MpgJson | null): Mpg {
    const mpg = new Mpg();

    if (json === null) {
      return mpg;
    }

    mpg.city = json.city;
    mpg.combined = json.combined;
    mpg.highway = json.highway;

    return mpg;
  }
}
